import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Server, Shield, Coins } from 'lucide-react';

export const SovereignNodesSection = () => {
  const { t } = useLanguage();

  return (
    <section id="sovereign-nodes" className="relative py-20 md:py-28 overflow-hidden">
      {/* Decorative grid background */}
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-[400px] h-[400px] bg-primary/10 rounded-full blur-[140px]" />
        <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-[#a3a3ff]/10 rounded-full blur-[140px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left — Headline */}
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/15 border border-primary/30 text-primary text-xs font-semibold tracking-wide uppercase">
              <Server className="w-3.5 h-3.5" />
              <span>We·R2 Chain · Validators</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-testid="sovereign-headline">
              {t('sovereign.headline')}
            </h2>

            <p className="text-lg text-slate-300 leading-relaxed max-w-xl">
              {t('sovereign.subtext')}
            </p>

            <a
              href="https://wer2ecosystem.com/#nodes"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-primary hover:text-white transition-colors text-sm font-medium"
              data-testid="sovereign-learn-more"
            >
              <span>{t('sovereign.learnMore')}</span>
              <span aria-hidden="true">→</span>
            </a>
          </div>

          {/* Right — Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="glass-card rounded-2xl p-6" data-testid="sovereign-stat-nodes">
              <div className="w-11 h-11 rounded-lg bg-primary/15 border border-primary/30 flex items-center justify-center mb-4">
                <Server className="w-5 h-5 text-primary" />
              </div>
              <div className="text-4xl font-bold text-white mb-1">151</div>
              <div className="text-sm text-slate-400">{t('sovereign.stat_nodes')}</div>
            </div>

            <div className="glass-card rounded-2xl p-6 sm:translate-y-6" data-testid="sovereign-stat-stake">
              <div className="w-11 h-11 rounded-lg bg-[#ffd166]/15 border border-[#ffd166]/30 flex items-center justify-center mb-4">
                <Coins className="w-5 h-5 text-[#ffd166]" />
              </div>
              <div className="text-4xl font-bold text-white mb-1">117,616</div>
              <div className="text-sm text-slate-400">{t('sovereign.stat_stake')}</div>
            </div>

            <div className="glass-card rounded-2xl p-6 sm:col-span-2" data-testid="sovereign-stat-consensus">
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 rounded-lg bg-[#a3a3ff]/15 border border-[#a3a3ff]/30 flex items-center justify-center">
                  <Shield className="w-5 h-5 text-[#a3a3ff]" />
                </div>
                <div>
                  <div className="text-sm text-slate-400">{t('sovereign.stat_consensus')}</div>
                  <div className="text-2xl font-bold text-white">{t('sovereign.consensus')} · Chain ID 111888</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
